import { render } from "./TransitionProvider.vue?vue&type=template&id=b5d99cc0&ts=true"
import script from "./TransitionProvider.vue?vue&type=script&lang=ts"
export * from "./TransitionProvider.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__